import request from "../../utils/request";
import { Result } from "../../models/general";

export interface OcrSettingsView {
  id: number;
  ocrEnabled: boolean;
  confidenceThreshold: number;
  autoDetectDocumentType: boolean;
  autoDetectExpiryDate: boolean;
  lastModifiedBy: string | null;
  lastModifiedAt: string | null;
}

export interface OcrSettingsInput {
  ocrEnabled: boolean;
  confidenceThreshold: number;
  autoDetectDocumentType: boolean;
  autoDetectExpiryDate: boolean;
}

export async function getOcrSettings() {
  const response = await request.get<Result<OcrSettingsView>>("OcrSettings");
  return response.data;
}

export async function updateOcrSettings(input: OcrSettingsInput) {
  const response = await request.put<Result<OcrSettingsView>>("OcrSettings", input);
  return response.data;
}
